
import { deepCopy } from 'fast-deep-copy'
import { ChunkId, CollectionState, StoryState } from './types'
import { CollectionAction } from './types'

function deactiveChunks(story: StoryState) {
  story.content.forEach((paragraph) => {
    paragraph.forEach((chunk) => {
      if(chunk.isSelected) {
        const hasContent = chunk.userComment !== null && chunk.userComment.trim().length > 0
        if(!hasContent) {
          chunk.userComment = null
        }
        chunk.isSelected = false
      }
    })
  })
}

function findChunk(story: StoryState, chunkId: ChunkId) {
  return story.content.flat().find((chunk) => chunk.id === chunkId)
}


const reducer = (state: CollectionState, action: CollectionAction) => {
  switch (action.type) {
    case 'initialize_state': {
      return action.state
    }

    case 'select_story': {
      const newState = deepCopy(state)
      const storyToActivate = newState.find((story) => story.id === action.id)
      if (!storyToActivate) return state
      newState.forEach((story) => {
        deactiveChunks(story)
        story.isActive = false
        story.mode = 'edit'
      })
      storyToActivate.isActive = true
      return newState
    }

    case 'set_mode': {
      const newState = deepCopy(state)
      const story = newState.find((story) => story.isActive)
      if (!story) return state
      deactiveChunks(story)
      story.mode = action.mode
      return newState
    }

    case 'select_chunk': {
      const newState = deepCopy(state)
      const story = newState.find((story) => story.isActive)
      if (!story) return state
      const chunk = findChunk(story, action.chunkId)
      if (!chunk) return state

      deactiveChunks(story)

      if (story.mode === 'edit') {
        // Add empty comment if one doesn't exist already
        if (!chunk.userComment) {
          chunk.userComment = ''
        }
        chunk.isSelected = true
        return newState
      }

      if (story.mode === 'review') {
        if (chunk.voxComment || chunk.userComment) {
          chunk.isSelected = true
        }
        return newState
      }

      return newState
    }

    case 'add_user_comment': {
      const newState = deepCopy(state)
      const story = newState.find((story) => story.isActive)
      if (!story) return state
      const chunk = findChunk(story, action.chunkId)
      if (!chunk) return state
      chunk.userComment = action.comment
      deactiveChunks(story)
      return newState
    }

    case 'next_story': {
      const newState = deepCopy(state)

      const activeStoryIndex = newState.findIndex((story) => story.isActive)
      if (activeStoryIndex === -1) return state

      const nextStoryIndex = activeStoryIndex + 1
      if (nextStoryIndex >= newState.length) return state

      const activeStory = newState[activeStoryIndex]
      activeStory.isActive = false
      activeStory.mode = 'edit'
      deactiveChunks(activeStory)

      newState[nextStoryIndex].isActive = true
      return newState
    }

    case 'prev_story': {
      const newState = deepCopy(state)

      const activeStoryIndex = newState.findIndex((story) => story.isActive)
      if (activeStoryIndex === -1) return state

      const nextStoryIndex = activeStoryIndex - 1
      if (nextStoryIndex < 0) return state

      const activeStory = newState[activeStoryIndex]
      activeStory.isActive = false
      activeStory.mode = 'edit'
      deactiveChunks(activeStory)

      newState[nextStoryIndex].isActive = true
      return newState
    }

    case 'remove_user_comment': {
      const newState = deepCopy(state)
      const story = newState.find((story) => story.isActive)
      if (!story) return state
      const chunk = findChunk(story, action.chunkId)
      if (!chunk) return state
      chunk.userComment = null
      chunk.isSelected = false
      return newState
    }

    default:
      return state
  }
}



export { reducer }